import { AssetfiAssetType } from '@/types/asset-type';

export default function PortfolioSvg({ width, height }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.0957 17.8101V16.3518C15.0957 13.9356 12.8571 11.9768 10.0957 11.9768H6.0957C3.33428 11.9768 1.0957 13.9356 1.0957 16.3518V17.8101M11.5957 4.97681C11.5957 6.9098 10.0287 8.47681 8.0957 8.47681C6.16271 8.47681 4.5957 6.9098 4.5957 4.97681C4.5957 3.04381 6.16271 1.47681 8.0957 1.47681C10.0287 1.47681 11.5957 3.04381 11.5957 4.97681Z"
        stroke="#242424"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
